import React from 'react';

/*
 *  @Description:   Stateless component that renders a User Icon.
 */

const Checkbox_Empty = ( props ) => {

    return (<g id="path">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        </g>
    )

};


export default Checkbox_Empty;

